import { stripHtml } from '../utils'

export default {
  methods: {
    stripHtml
  }
}
